import Vue from 'vue';
import * as _ from 'lodash';
import BookmarkBuilderConfig from "../../models/bookmarkBuilderConfig";
import BookmarkLink from "../../models/bookmarkLink";
import {findSelectedConfigsFromRoute, configForUser, configsToSelectViaDefaults} from "../bookmarkLinkBuilderInterfaceStoreHelper";
import {RegexHelper} from "../../../../common/helpers/regexHelper";
import QuickLink from "../../../organization_management/models/quickLink";

const clearState = function (state) {
  const userConfig = configForUser(BookmarkBuilderConfig, state);
  Vue.set(state, 'selectedConfigs', [userConfig]);
  state.selectedInstanceObject = null;
  state.selectedInstanceObjectType = null;
  state.textInput = '';
  state.textInputInvalid = false; // messy =(
};

export default function () {
  return {
    namespaced: true,
    state: {
      user: null,
      organization: null,
      portalsForDropdownSelect: null,
      selectedConfigs: [],
      selectedInstanceObject: null,
      selectedInstanceObjectType: null,
      textInput: '',
      textInputInvalid: false,
    },
    getters: {
      linkPartialJson(state) {
        const jsonObj: any = {};

        const route = _.last(state.selectedConfigs)['route'];
        if (route) {
          jsonObj.route = route;
        }

        if (state.selectedInstanceObject) {
          jsonObj.instance_object_id = state.selectedInstanceObject.id;
          jsonObj.instance_object_type = state.selectedInstanceObjectType;
        }

        const textInput = state.textInput;
        if (textInput && (textInput.length > 0)) {
          jsonObj.url = textInput;
        }

        return jsonObj;
      },
    },
    mutations: {
      setUser(state, user) {
        state.user = user;
        clearState(state);
      },
      setOrganization(state, organization) {
        state.organization = organization;
        clearState(state);
      },
      setPortalsForDropdownSelect(state, portals) {
        state.portalsForDropdownSelect = portals;
      },
      clearState(state) {
        clearState(state);
      },
      setSelectedConfig(state, {config, level}) {
        const lastConfigIndex = (state.selectedConfigs.length - 1);
        const numToRemove = lastConfigIndex - level + 1;
        const configsToSelect = configsToSelectViaDefaults(config);

        state.selectedConfigs.splice(level, numToRemove, ...configsToSelect);

        const keepSelectedInstanceObject = _.some(state.selectedConfigs, function (selectedConfig) {
          return selectedConfig.instanceObjectSelect;
        });
        if (!keepSelectedInstanceObject) {
          state.selectedInstanceObject = null;
        }

        const keepTextInput = _.some(state.selectedConfigs, function (selectedConfig) {
          return selectedConfig.textInput;
        });
        if (!keepTextInput) {
          state.textInput = '';
          state.textInputInvalid = false;
        }
      },
      setStateFromLink(state, {link, isEditing}: {link: BookmarkLink | QuickLink, isEditing: boolean}) {
        clearState(state);

        if (link.url) {
          state.textInput = link.url;

          const hyperLinkConfig = _.find(BookmarkBuilderConfig.children, function (config) {
            return config.children && config.children[0]['textInput'];
          });
          Vue.set(state, 'selectedConfigs', [BookmarkBuilderConfig, hyperLinkConfig]);
        } else if (link.route) {
          // allow existing link to visit all config nodes when showing only
          const rootConfig = isEditing ? configForUser(BookmarkBuilderConfig, state) : BookmarkBuilderConfig;
          const newSelectedConfigs = findSelectedConfigsFromRoute(link.route, rootConfig);

          if (newSelectedConfigs) {
            Vue.set(state, 'selectedConfigs', [...newSelectedConfigs]);
          }

          if (link.instance_object) {
            state.selectedInstanceObject = link.instance_object;
          }
        }
      },
      setSelectedInstanceObject(state, obj) {
        state.selectedInstanceObject = obj;
      },
      setSelectedInstanceObjectType(state, type: string) {
        state.selectedInstanceObjectType = type;
      },
      setTextInput(state, text: string) {
        state.textInput = text;
        state.textInputInvalid = false;
      },
      validateTextInput(state) {
        const textInput = state.textInput;
        let valid = false;

        if (textInput.match(RegexHelper.url)) {
          valid = true;
        } else if (textInput.startsWith('/')) {
          const url = 'https://formability.com' + textInput;
          if (url.match(RegexHelper.url)) {
            valid = true
          }
        }

        state.textInputInvalid = !valid
      },
    },
  };
}
